'use client';

import { apiClient } from '@/lib/apiClient';
import { useCachedQuery } from '@/api/queryCache';
import type { SignupMode } from '@/lib/signupMode';

export interface LandingConfiguration {
  signup_mode: SignupMode;
}

const fetchLandingConfiguration = () =>
  apiClient<never, LandingConfiguration>('/v1/landing/configuration', { method: 'GET' });

/**
 * Configurazione pubblica della landing. Oggi contiene solo `signup_mode`, che
 * arriva da Admin → Preferences: la modalità di registrazione cambia senza
 * deploy. Se la preferenza manca, il backend risponde `demo_and_trial`.
 */
export function useLandingConfiguration() {
  return useCachedQuery('landing-configuration', fetchLandingConfiguration);
}
